import request from '@/request/user'
import { getToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'
import { Message } from 'element-ui'
const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    logo: require('@/assets/logo.png'),
    userIcon: require('@/assets/icon_mrtx.png')
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  }
}

const actions = {
  setToken({ commit }, data) {
    commit('SET_TOKEN', data)
  },
  getInfo({ commit }, name) {
    commit('SET_NAME', name)
  },

  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      request.logout().then((res) => {
        if (res.code === 2000) {
          removeToken()
          resetRouter()
          commit('RESET_STATE')
          resolve()
        } else {
          Message.error(res.message)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken()
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

